<template>
  <div class="todo-list">
    <p class="fileTitle">{{t('ai.modulesCompleted')}}</p>
    <div v-for="(item,index) in todoListModule" :key="index">
      <div class="todo-item">
        <div>
          <img :src="image.file" alt="">
          <span class="mr8">{{item.name}}</span>
          <span class="un-comleted">({{t('ai.isRequired')}})</span>
        </div>
        <el-button size="small" @click="handleToComplete(item)">{{t('ai.toComplete')}}</el-button>
      </div>
    </div>
    <p v-show="!todoListModule.length" class="noData"></p>
    <div v-for="(item,fileIndex) in todoListFile" :key="`${fileIndex}${item.name}`">
      <div class="fileTitle">
        <span class="fileTitle">{{item.name}} 
          <span v-show="fileIndex!==0" class="fileTitle">({{t('ai.filesToUpload')}})</span>
        </span>
      </div>
      <div v-for="(itemChild,jindex) in item.list" :key="jindex">
        <div class="todo-item">
          <div>
            <img :src="image.file" alt="">
            <span class="mr8">{{itemChild.name}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import i18n from "@/locale/index";
import {
  getStudentFileDataApi,
} from "@/api/common.js";
export default {
  name: "todoList",
  mixins: [i18n],
  inject: ['stuid'],
  props:{
    navDynamic:{
      type: Array,
      defalut: () => []
    },
    studentFileUploadList:{
      type: Array,
      defalut: () => []
    },
  },
  computed:{
    completed() {
      return this.$root.toolState.completed || []
    },
    UnCompleted() {
      return this.$root.toolState.UnCompleted || []
    },
    uploadFiles() {
      return this.$root.toolState.uploadFiles || []
    },
  },
  data(){
    return{
      image:{
        file:require('@/assets/ai-upload/file.png'),
      },
      // 待办模块
      todoListModule:[],
      // 待上传文件
      todoListFile:[],
      // 已上传文件
      uploadedFiles:[],
    }
  },
  mounted(){
    this.getStudentFileData();
  },
  methods:{
    checkTodoList(){
      this.todoListFile=[];
      this.todoListModule=[];
      // 只显示必填的模块
      if(this.navDynamic&&this.navDynamic.length){
        for(const item of this.navDynamic){
          if(item.isRequired&&this.UnCompleted.includes(item.divisionKey)){
            this.todoListModule.push(item);
          }
        }
      }
      // 从上传文件列表中剔除已上传文件
      if(this.studentFileUploadList&&this.studentFileUploadList){
        const studentFileUploadList=JSON.parse(JSON.stringify(this.studentFileUploadList));
        for(const item of studentFileUploadList){
          if(item.id===0){
            item.name=this.t('ai.filesToUpload');
          }
          let list=[];
          for(const listItem of item.list){
            const show=this.handleActive(listItem,item.id);
            if(show){
              list.push(listItem);
            }
          }
          item.list=list;
          if(item.list&&item.list.length){
            this.todoListFile.push(item)
          }
        }
      }
    },
    handleActive(data,index){
      let bool=true;
      for(const item of this.uploadedFiles){
        if(
          (index===0||item.fkStudentInstitutionCourseIdOne===data.studentCourseId)&&
          item.typeKey===data.typeKey
        ){
          bool=false;
        }
      }
      return bool
    },
    // 获取已上传文件数量
    async getStudentFileData() {
      this.uploadedFiles=[];
      const { data } = await getStudentFileDataApi(this.stuid());
      if (data.datas && data.datas.length!==0){
        this.uploadedFiles = data.datas
        this.checkTodoList();
      }
    },
    handleToComplete(item){
      this.$emit('toComplete',item);
    }
  },
}
</script>
<style lang="scss" scoped>
.todo-list{
  max-height:350px;
  overflow: auto;
  .todo-item{
    display: flex;
    padding: 8px 12px 8px 8px;
    align-items: center;
    justify-content: space-between;
    border-radius: 8px;
    border: 1px solid #E1E1E1;
    background: #F9F9F9;
    margin-bottom:16px;
    >div{
      display: flex;
      align-items: center;
      
    }
    img{
      width:40px;
      margin-right:12px;
    }
  }
  .fileTitle{
    font-weight: bold;
    color:#606266;
    text-align: left;;
  }
  .themeColor{
    color:#ff9700;
  }
  .noData{
    width:100px;
    height:100px;
    background: url('../../../src/assets/ai-upload/noData.png') no-repeat;
    background-size: cover;
    margin:0 auto;
  }
  .un-comleted {
    color: #E74C3C;
  }
  .mr8{
    margin-right:8px;
  }
}
</style>